export const FETCH_GET_ATTACHMENT = 'FETCH_GET_ATTACHMENT';
export const FETCH_DOWNLOAD_ATTACHMENT = 'FETCH_DOWNLOAD_ATTACHMENT';
export const FETCH_ADD_ATTACHMENT = 'FETCH_ADD_ATTACHMENT';
export const FETCH_DELETE_ATTACHMENT = 'FETCH_DELETE_ATTACHMENT';
